import { Box } from "@mui/material"
import React, { useEffect } from "react"
import { useParams } from "react-router-dom"

import OpenLootbox from "../../components/modules/lootBoxes/OpenLootbox/index"
import { useLootbox } from "../../contexts/LootboxContext"

const LootboxOpenPage = (): JSX.Element => {
  const { setLootboxToOpen } = useLootbox()
  const { lootboxAddress } = useParams()

  useEffect(() => {
    setLootboxToOpen(lootboxAddress)
    return () => {
      setLootboxToOpen(undefined)
    }
  }, [lootboxAddress, setLootboxToOpen])

  return (
    <Box pt={1} pb={1}>
      <OpenLootbox />
    </Box>
  )
}

export default LootboxOpenPage
